import React from "react";
import { Box, Card, Divider, Grid, Paper, Typography } from "@material-ui/core";
import TabHeader from "src/components/TabHeader/TabHeader";
import { useStyles } from "./components/style";
import { ManifestEntryForm } from "./components/ManifestEntryForm";

export default function ManifestEntry(): React.ReactElement {
  const classes = useStyles();
  const moduleName = "Gate Entry";
  const pageHeading = "Manifest Entry";

  return (
    <>
      <TabHeader module={moduleName} heading={pageHeading} link={"/gate-entry"} />
      <Box m={2} />
      <Grid container direction="row">
        <Grid item xs={12} md={12} className={classes.cardMainParent}>
          <Paper elevation={3} className={classes.cardMain}>
            <Box pl={2} pr={2}>
              <Grid container direction="row">
                <Grid item xs={12} md={7}>
                  <Typography className={classes.pageHeading}>{pageHeading}</Typography>
                </Grid>
              </Grid>
            </Box>
            <Box m={1}>
              <Divider />
            </Box>

            <Grid container>
              <Grid item xs={12} component={Card} className={classes.tabCardContent}>
                <ManifestEntryForm />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
